import React, { createContext, useContext, useState, useCallback } from "react";
// Import articles and labels from separate JSON files
import articlesData from "../data/articles.json";
import labelsData from "../data/labels.json";

// 1) Create the context
const ArticlesContext = createContext();

// 2) Provider component
export const ArticlesProvider = ({ children }) => {
  // Load articles from JSON
  const [articles, setArticles] = useState(articlesData);

  // Load labels from JSON
  const [labels, setLabels] = useState(labelsData);

  // (Example) Utility: Given an article, return its full label objects
  const getLabelsForArticle = useCallback(
    (article) => {
      if (!article.labels) return [];
      return article.labels
        .map((labelId) => labels.find((lbl) => lbl.id === labelId))
        .filter(Boolean);
    },
    [labels]
  );

  // (Example) Utility: Add a new article, ensuring its label IDs are valid
  const addArticle = useCallback(
    (newArticle) => {
      if (newArticle.labels) {
        const validLabels = newArticle.labels.every((id) =>
          labels.some((lbl) => lbl.id === id)
        );
        if (!validLabels) {
          throw new Error("One or more labels do not exist in the label list.");
        }
      }
      setArticles((prev) => [...prev, newArticle]);
    },
    [labels]
  );

  return (
    <ArticlesContext.Provider
      value={{ articles, labels, getLabelsForArticle, addArticle }}
    >
      {children}
    </ArticlesContext.Provider>
  );
};

// 3) Custom hook to access the context
export const useArticlesContext = () => useContext(ArticlesContext);